import { RouteRecordRaw } from 'vue-router';

export const roadmapRoutes: RouteRecordRaw[] = [
  {
    path: '/roadmap',
    name: 'RoadmapPage',
    component: () => import('@/pages/roadmap/RoadmapPage.vue'),
  },
];
